import { configureStore } from '@reduxjs/toolkit';
import taskActivityReducer from '../features/taskactivity/TaskActivitySlice';

export const store = configureStore({
  reducer: {
    "taskactivity": taskActivityReducer
  },
});
